import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
export default function NotificationBanner() {
    const { t } = useTranslation();
    return (React.createElement("div", { style: {
            backgroundColor: '#FFF3CD',
            borderRadius: '4px',
            padding: '16px',
        } },
        React.createElement("h3", null, t('notification-banner.important-notice')),
        React.createElement("p", { style: { whiteSpace: 'pre-line' } },
            React.createElement(Trans, { i18nKey: "notification-banner.new-version-announcement", components: {
                    a: React.createElement("a", { href: "https://u-valuecalculator.com/gb", target: "_blank", rel: "noopener noreferrer" }),
                } }))));
}
